import { Payment, BillingIntervalEnum, Card, Stripe } from "@finway-group/shared/lib/models"
import { validEmail, validObjectId } from "./shared"

export const cardInfo: any = {
    brand: "Mastercard",
    country: "Germany",
    expMonth: 9,
    expYear: 23,
    funding: "none",
    lastFourDigits: "5465",
}

export const stripeInfo: Stripe = {
    customerId: validObjectId,
    subscriptionId: "203382697452811920938269",
    paymentMethod: "card",
} as Stripe

export const payment: Payment = {
    billingEmail: validEmail,
    billingName: "My Payment",
    billingInterval: BillingIntervalEnum.MONTHLY,
    subscriptionStart: new Date(2019, 9, 21),
    nextBillingDate: new Date(2022, 9, 14),
    isCancelled: false,
    cardInfo: cardInfo,
    stripeData: stripeInfo,
    status: "active",
} as Payment
